/**
 * Generate safe IDs with fallback to prevent "panelundefined" and "tabundefined"
 * First tab (index 0) will be named "panel" and "tab" instead of "panel0" and "tab0"
 * Only applies when no ID is supplied - supplied IDs are used as-is
 */
export function generateSafeIds(
	id: string | number | undefined,
	panelIndex: number | undefined,
): { panelId: string; tabId: string } {
	const idString = id !== null && id !== undefined ? String(id) : '';
	const isValidId =
		id !== null &&
		id !== undefined &&
		idString !== 'undefined' &&
		idString !== '' &&
		idString !== 'null';

	let safeId: string | number;
	if (isValidId) {
		safeId = id;
	} else if (panelIndex !== null && panelIndex !== undefined && typeof panelIndex === 'number') {
		safeId = panelIndex === 0 ? '' : panelIndex;
	} else {
		safeId = 'default';
	}

	const safeIdString = String(safeId);
	return {
		panelId: `panel${safeIdString}`,
		tabId: `tab${safeIdString}`,
	};
}
